var moduleMap = {
	"./StatusPage": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_ucl_styles_themes_designSystem_pro_light_js-node_modules_react_jsx-runtime_js"), __webpack_require__.e("vendors-node_modules_ucl_core_accordion_js-node_modules_ucl_core_breadcrumb_js-node_modules_u-6d5da8"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_emotion_react_emotion_react"), __webpack_require__.e("webpack_sharing_consume_default_i18next_i18next"), __webpack_require__.e("src_pages_StatusPage_tsx-webpack_sharing_consume_default_emotion_styled_emotion_styled-webpac-f5d619")]).then(() => (() => ((__webpack_require__(/*! ./src/pages/StatusPage */ "./src/pages/StatusPage.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});